import _objectSpread from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["value", "endAdornmentText", "required", "minLength", "maxLength", "email", "readOnly", "customRef", "onChange", "onBlur", "error", "xs", "md", "lg", "margin", "minValue", "maxValue", "forceError"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import { Block } from '../content';
const TextBox = _ref => {
  let {
      value,
      endAdornmentText,
      required,
      minLength,
      maxLength,
      email,
      readOnly,
      customRef = false,
      onChange,
      onBlur,
      error,
      xs,
      md,
      lg,
      margin = 'normal',
      minValue,
      maxValue,
      forceError
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const [errorMessage, setErrorMessage] = useState(error);
  const [localDefaultValue, setLocalDefaultValue] = useState(value);
  const requiresValidation = required || minLength || maxLength || email || minValue || maxValue;
  rest.inputProps = _objectSpread({
    requiredstr: required ? 'true' : 'false',
    minlengthval: minLength,
    maxlengthval: maxLength,
    min: minValue,
    max: maxValue,
    emailval: email ? 'true' : 'false',
    step: rest.step && rest.step
  }, rest.inputProps);
  let ref;
  if (!customRef) {
    ref = requiresValidation && /*#__PURE__*/React.createRef();
  } else {
    ref = customRef;
  }
  const onBlurHandler = event => {
    setErrorMessage(null);
    setLocalDefaultValue(event.target.value);
    onBlur && onBlur(event.target.value);
  };
  const onChangeHandler = event => {
    onChange && onChange(event.target.value, event);
  };
  useEffect(() => {
    const validationListener = event => {
      // console.log('EVENT', event);
      event.stopPropagation();
      setErrorMessage(t(event.target.errormsg).replace('[nome]', rest.label).replace('[errormsgparam]', event.target.errormsgparam));
      setLocalDefaultValue(event.target.value);
    };
    if (!customRef) {
      const node = ref && ref.current;
      node && node.addEventListener('invalid-data', validationListener);
      return () => {
        node && node.removeEventListener('invalid-data', validationListener);
      };
    }
  }, [ref, rest.label, t, customRef]);
  if (endAdornmentText) {
    rest.InputProps = _objectSpread(_objectSpread({}, rest.InputProps), {}, {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, endAdornmentText)
    });
  }
  if (readOnly) {
    rest.inputProps.readOnly = readOnly;
  }
  if (errorMessage || forceError && error) {
    rest.error = true;
    rest.helperText = errorMessage || error;
  }
  if (!xs && !md) {
    rest.margin = margin;
  }
  const content = /*#__PURE__*/React.createElement(TextField, _extends({
    color: "secondary",
    defaultValue: localDefaultValue === undefined || localDefaultValue === null ? '' : localDefaultValue,
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    inputRef: !customRef ? ref : customRef
  }, rest));
  if (xs || md || lg) {
    let marginProps;
    if (margin === 'normal') {
      marginProps = {
        margin: 4,
        marginBottom: 2
      };
    } else if (margin === 'none') {
      marginProps = {
        margin: 0
      };
    } else {
      marginProps = {
        margin
      };
    }
    return /*#__PURE__*/React.createElement(Block, _extends({
      xs: xs,
      md: md,
      lg: lg
    }, marginProps), content);
  }
  return content;
};
TextBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  onBlur: PropTypes.func,
  endAdornmentText: PropTypes.any,
  autoComplete: PropTypes.string,
  id: PropTypes.string
};
TextBox.defaultProps = {
  margin: 'normal'
};
export default TextBox;